<template>
  <div class="container">
    <form @submit.prevent="onSubmit" class="row px-2">
      <AlertDismiss ref="alertDismiss" class="alert-sticky"></AlertDismiss>
      <div v-if="anonymous" class="mb-2 px-0 row">
        <b-form-group label="Nombre:" class="col-sm-4" label-size="sm">
          <b-form-input v-model="accuser.name" type="text" placeholder="Ingrese su nombre" size="sm"></b-form-input>
        </b-form-group>

        <b-form-group class="col-sm-4" label="Correo electrónico:" label-size="sm">
          <b-form-input v-model="accuser.email" type="email" class="form-control" placeholder="Ingrese su correo"
            size="sm"></b-form-input>
        </b-form-group>

        <label class="col-sm-4">
          <RUTInput label="RUT" v-model="accuser.rut" size="sm" :required="true"/>
        </label>
      </div>

      <div class="form-group mb-0 px-0">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" v-model="isRepresenting">
          <label class="form-check-label d-flex align-items-center form-check-label-sm">
            ¿Está representando a otra persona?
            <div v-if="!anonymous" v-b-tooltip.hover
              title="La denuncia se registra por defecto a nombre del usuario que haya iniciado la sesión">
              <b-icon class="ms-2" icon="question-circle" small variant="primary"></b-icon>
            </div>
          </label>
        </div>
      </div>

      <div v-if="isRepresenting" class="px-0 row">
        <div class="col-md-4">
          <b-form-group label="Nombre:" class="mb-2" label-size="sm">
            <b-form-input v-model="form.represented.name" type="text" class="form-control"
              placeholder="Ingrese el nombre del afectado" size="sm"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-4">
          <b-form-group label="Correo electrónico:" class="mb-2" label-size="sm">
            <b-form-input v-model="form.represented.email" type="email" class="form-control"
              placeholder="Ingrese el correo del afectado" size="sm" />
          </b-form-group>
        </div>

        <div class="col-md-4">
          <RUTInput label="RUT" v-model="form.represented.rut" size="sm" />
        </div>

        <div class="col">
          <b-form-group label="Representación invocada:" class="mb-2" label-size="sm">
            <b-form-input v-model="form.represented.relationship" type="text" class="form-control"
              placeholder="Tipo de representación legal mediante la cual actúa en nombre del afectado" size="sm"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="card mt-2 px-2">
        <div class="card-body p-2 px-1">
          <ListEdit v-model="modelAccused" label="Personas denunciadas" :minItems="1" @handleAdd="handleAddAccused"
            @handleRemove="handleRemoveAccused">
            <template #default="{ index }">
              <div class="mb-2 d-flex gap-2">
                <input type="text" class="form-control form-control-sm" v-model="modelAccused[index].name"
                  :placeholder="'Nombre ' + (index + 1)" required>

                <input type="text" class="form-control form-control-sm" :value="rutDisplayValue(index)"
                  @input="handleInputRUT($event, index)" @focus="handleFocusRUT(index)" @blur="handleBlurRUT(index)"
                  @keypress="validateRut" :placeholder="'RUT ' + (index + 1)" :maxlength="9" inputmode="numeric" required>

                <input type="email" class="form-control form-control-sm" v-model="modelAccused[index].email"
                  :placeholder="'Email ' + (index + 1)" required>

                <input type="text" class="form-control form-control-sm me-2" v-model="modelAccused[index].position"
                  :placeholder="'Cargo ' + (index + 1)" required>
              </div>
            </template>
          </ListEdit>

          <div v-if="hasAccused">
            <div class="d-flex align-items-center gap-1">
              <div class="form-check mb-0">
                <input class="form-check-input" type="checkbox" v-model="isExternal" id="externalCheck">
                <label class="form-check-label" for="externalCheck">
                  <small>
                    {{ isExternalLabel }}
                  </small>
                </label>
              </div>
              <textarea v-model="form.accusedRelationship" type="email" class="form-control form-control-sm" required
                :placeholder="relationshipPlaceholder" />
            </div>
          </div>

        </div>
      </div>

      <div class="d-flex px-0 mt-2">
        <div class="form-group mb-2 flex-shrink-0">
          <label>Tipo de denuncia:</label>
          <select class="form-select form-select-sm" v-model="form.denunciationTypeId" required>
            <option :value="null" disabled selected>-- Seleccione un tipo de denuncia --</option>
            <option v-for="type in denunciationTypes" :key="type.id" :value="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>

      </div>

      <div class="form-group mb-2 px-0">
        <label>Detalles de la denuncia:</label>
        <textarea type="date" class="form-control form-control-sm" v-model="form.details" required
          placeholder="Relacione los hechos denunciados" />
      </div>

      <div class="form-group col-auto mb-2 px-0">
        <label for="fileInput">Evidencia</label>
        <input type="file" class="form-control form-control-sm" id="fileInput" ref="fileInput"
          @change="handleFileChange" accept=".pdf,application/pdf">
      </div>

      <div class="form-group mb-2 px-0">        <input class="form-check-input me-2" type="checkbox" id="protectionCheck" v-model="form.protection">
        <label for="protectionCheck">Se solicitan medidas de protección para el afectado</label>
      </div>

      <div class="form-group row px-0">
        <div class="col-sm-3">
          <button type="submit" class="btn btn-primary w-100" :disabled="isUploading">
            <b-spinner small v-show="isUploading"></b-spinner>
            Denunciar
          </button>
        </div>
        <div class="col-sm-9" v-show="progress">
          <ProgressCustom ref="progressBar"></ProgressCustom>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import ProgressCustom from '@/components/shared/Progress-custom.vue';
import { EventNames } from '@/plugins/enums';
import { mapActions, mapGetters } from 'vuex';
import { InitPageSize } from '@/plugins/enums';
import RUTInput from '@/components/shared/RUT-input.vue';
import ListEdit from '@/components/shared/List-edit.vue';
import { formatRut, validateRut } from '@/plugins/complianceScripts/index.js'

export default {
  name: 'KarinForm',

  components: {
    AlertDismiss,
    ProgressCustom,
    RUTInput,
    ListEdit
  },

  props: {
    anonymous: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isRepresenting: false,
      denunciationTypes: [],
      modelAccused: [],
      isExternal: false,

      accuser: {
        name: "",
        rut: "",
        email: "",
      },

      form: {
        denunciationTypeId: null,
        accuserId: null,
        accusedRelationship: "",
        documentRoute: null,
        details: "",
        protection: false,
        represented: {
          name: "",
          rut: "",
          email: "",
          relationship: ""
        }
      },

      progress: 0,
      file: null,
      isUploading: false,
      denunciationId: null
    }
  },

  computed: {
    ...mapGetters(["getSession"]),

    relationshipPlaceholder() {
      return this.isExternal ?
        'Vinculo que se tiene con el denunciado externo a la empresa' :
        'Vinculo organizacional que tiene la persona afectada con el/los denunciado(s)';
    },

    isExternalLabel() {
      return this.modelAccused.length > 1 ?
        "Los denunciados son externos a la empresa" :
        "El denunciado es externo a la empresa";
    },

    hasAccused() {
      return this.modelAccused.length > 0;
    }
  },

  async mounted() {
    this.handleAddAccused()
    await this.getDenunciationTypes();
  },

  methods: {
    validateRut,
    ...mapActions([
      "createKarinDenunciation",
      "getKarinAccuserByMail",
      "getKarinDenunciationTypes",
      "uploadFileKarinDenunciation",
      "createKarinAccusersAnonymous",
      "addDocumentKarinDenunciation",
    ]),

    async onSubmit() {
      this.isUploading = true;

      if (!this.form.accuserId) {
        this.setProgress(10, "Obteniendo información denunciante...")
        let accuserResult = await this.getAccuserId()
        if (!accuserResult) {
          this.resetSubmitProcess();
          return;
        }
      }

      this.setProgress(30, "Creando denuncia...")
      let result = await this.saveDenunciation();
      if (!result) {
        this.resetSubmitProcess();
        return;
      }

      if (this.file && !this.form.documentRoute) {
        this.setProgress(50, "Subiendo documento evidencia...")
        let uploadResult = await this.uploadFile()
        if (!uploadResult) {
          this.resetSubmitProcess();
          return;
        }

        this.setProgress(95, "Asignando evidencia...")
        let assignResult = await this.assignDocument()
        if (!assignResult) {
          this.resetSubmitProcess();
          return;
        }
      }

      this.setProgress(100, "Completado")
      setTimeout(() => {
        this.setProgress(0)
      }, 1000)

      this.$eventBus.$emit(EventNames.CreatedKarinDenunciation, {
        page: 1,
        pageSize: InitPageSize.KarinDenouncePageSize
      });

      this.$refs.alertDismiss.showAlert('Denuncia enviada correctamente', 'success')

      this.clear()

      this.isUploading = false;
    },

    async getAccuserId() {
      let user = await this.getAccuserIdFromMail();
      if (user) { // not registered users return null
        this.form.accuserId = user.id;
        return true;
      }

      // the user is not registered in the system
      let userIdResult = await this.createKarinAccusersAnonymous({
        name: this.accuser.name,
        mail: this.accuser.email,
        rut: this.accuser.rut
      });

      if (userIdResult.isError) {
        this.$refs.alertDismiss.showAlert(userIdResult.message);
        return false;
      }

      this.form.accuserId = userIdResult.data;
      return true;
    },

    async getAccuserIdFromMail() {
      let result = await this.getKarinAccuserByMail({ mail: this.anonymous ? this.accuser.email : this.getSession.mail });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return false;
      }

      return result.data
    },

    async uploadFile() {
      if (!this.file) {
        this.$refs.alertDismiss.showAlert('Debe seleccionar un archivo.');
        return false;
      }

      let result = await this.uploadFileKarinDenunciation(this.file);

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return false;
      }

      this.form.documentRoute = result.data;
      return true;
    },

    async assignDocument() {
      let result = await this.addDocumentKarinDenunciation({
        route: this.form.documentRoute,
        denunciationId: this.denunciationId
      });

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return false;
      }

      return true;
    },

    async saveDenunciation() {
      let sendForm = {
        descripcion: this.form.details,
        accuserId: this.form.accuserId,
        denunciationTypeId: this.form.denunciationTypeId,
        preventive: this.form.protection,

        peopleReported: this.modelAccused.map(accused => {
          return {
            name: accused.name,
            rut: accused.rut,
            mail: accused.email,
            posicion: accused.position,
          }
        })
      }

      if (this.file) {
        sendForm.documentRoute = this.form.documentRoute
      }

      sendForm.external = {
        isExternal: this.isExternal,
        link: this.form.accusedRelationship
      }
      if (this.isRepresenting) {
        sendForm.affected = {
          name: this.form.represented.name,
          rut: this.form.represented.rut,
          mail: this.form.represented.email,
          representation: this.form.represented.relationship
        }
      }

      let result = await this.createKarinDenunciation(sendForm);

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return false;
      }

      this.denunciationId = result.data

      return true
    },

    async getDenunciationTypes() {
      let result = await this.getKarinDenunciationTypes();

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return null;
      }

      this.denunciationTypes = result.data.sort((a, b) => a.name.localeCompare(b.name));
    },

    handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        this.file = file
        this.form.documentRoute = null
      }
    },

    handeMailChange() {
      this.form.accuserId = null
    },

    setProgress(value, message = '') {
      this.progress = value;
      this.$refs.progressBar.progress(value, message);
    },

    resetSubmitProcess() {
      this.setProgress(0)
      this.isUploading = false;
      this.denunciationId = null
    },

    handleAddAccused() {
      this.modelAccused.push({
        name: '',
        rut: '',
        email: '',
        position: '',
        __focused: false
      })
    },

    handleRemoveAccused(index) {
      this.modelAccused.splice(index, 1)
    },

    clear() {
      this.file = null
      this.$refs.fileInput.value = null
      this.modelAccused = []
      this.handleAddAccused()
      this.isExternal = false

      this.form = {
        denunciationTypeId: null,
        accuserId: null,
        accusedRelationship: "",
        documentRoute: null,
        details: "",
        protection: false,
        represented: {
          name: "",
          rut: "",
          email: "",
          relationship: ""
        }
      }

      this.accuser = {
        name: "",
        rut: "",
        email: "",
      }
    },

    handleInputRUT(event, index) {
      this.modelAccused[index].rut = event.target.value;
    },

    handleFocusRUT(index) {
      this.modelAccused[index].__focused = true
    },

    handleBlurRUT(index) {
      this.modelAccused[index].__focused = false
    },

    rutDisplayValue(index) {
      let value = this.modelAccused[index].rut
      if (this.modelAccused[index].__focused) {
        return value
      }

      return value ? formatRut(value) : ''
    },
  },

  watch: {
    file() {
      this.form.documentRoute = null
    }
  }
}
</script>

<style scoped>
.alert-sticky {
  position: sticky;
  top: 0;
  z-index: 100;
}

.container {
  overflow-y: auto;
  max-height: 80vh;
}
</style>